import Logger from '@/helpers/logger';
import { ERROR_TYPES } from '@/config/error-types';

class RequestHelper {
	/**
	 * Request Help function
	 */
	//@ts-ignore
	static async request(callback, requestData, isEmptyResponse = false) {
		if (!navigator.onLine) {
			throw new Error(ERROR_TYPES.CONNECTION_ERROR);
		}
		const response = await callback(requestData);

		if (isEmptyResponse) {
			return null;
		}

		const { data } = response;
console.log(response);

		if ('errNo' in data && data.errNo !== 0) {
			let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
			if (data.Errors && data.Errors.length) {
				const [firstError] = data.Errors;
				({ errMsg } = firstError);
			}
			throw new Error(errMsg);
		}

		return data;
	}
}

export default RequestHelper;
